import { useContext } from "react";
import { GameState } from "./GameState";

function StatusBar() {
  const state = useContext(GameState);

  return (
    <div className="status-bar">
      <div className="scorelabel">Score: ${Math.floor(state.score).toLocaleString()}</div>
    </div>
  );
}

export default StatusBar;
